/* eslint-disable @typescript-eslint/no-unused-vars */
import { IconButton, IconButtonProps, Stack, styled, Typography } from '@mui/material';
import { Close, Download, Mail, Printer } from 'mdi-material-ui';
import { VigoTypography } from 'src/@vigo/vigo-typography';

interface ViewerHeaderProps {
  handleClose: () => void;
  count: number;
  handleEmailClick: () => void;
  handleDownloadClick: () => void;
  useOverride: boolean;
}

const StyledIconButton = styled(IconButton)<IconButtonProps>(() => ({
  '&:hover': { borderRadius: '4px', backgroundColor: '#626679', color: '#fff' }
}));

const ViewerHeader = ({
  handleClose,
  count = 0,
  handleEmailClick,
  handleDownloadClick,
  useOverride
}: ViewerHeaderProps) => {
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center" mb="10px">
      <Stack direction="row" alignItems={'center'} gap="5px" sx={{ '& > small': { transform: 'translateY(1px)' } }}>
        <VigoTypography sx={{ fontSize: '1.143rem', fontWeight: '600' }} value={`${'Document Viewer'}`} />
        <small>{`(${count})`}</small>
      </Stack>

      <Stack
        direction="row"
        sx={{
          'button:last-of-type': {
            marginLeft: '10px'
          }
        }}>
        {!useOverride && (
          <StyledIconButton onClick={handleEmailClick}>
            <Mail />
          </StyledIconButton>
        )}
        {/* Hide these till we impliment */}
        <StyledIconButton onClick={handleDownloadClick}>
          <Download />
        </StyledIconButton>
        {/* <StyledIconButton>
          <Printer />
        </StyledIconButton> */}
        <StyledIconButton onClick={handleClose}>
          <Close />
        </StyledIconButton>
      </Stack>
    </Stack>
  );
};

export default ViewerHeader;
